'use client';
function getSplitOffset({ data, dataKey }) {
  const dataMax = Math.max(...data.map((item) => item[dataKey]));
  const dataMin = Math.min(...data.map((item) => item[dataKey]));
  if (dataMax <= 0) {
    return 0;
  }
  if (dataMin >= 0) {
    return 1;
  }
  return dataMax / (dataMax - dataMin);
}
function getDefaultSplitOffset({ data, series }) {
  if (series.length === 1) {
    const dataKey = series[0].name;
    return getSplitOffset({ data, dataKey });
  }
  return 0.5;
}

export { getDefaultSplitOffset, getSplitOffset };
//# sourceMappingURL=get-split-offset.mjs.map
